import {
  BuildGetArgs,
  BuildPostArgs,
  RequestArgs,
  buildGet,
  buildPost,
  performFetch,
  handleJSON,
} from 'lib/network/http';
import { getToken } from './auth';
import { AUTH_HTTP_SOURCE_FILE } from 'approot/shared/api/auth/auth.constants';

export const requestAuthorised = (
  args: RequestArgs,
  AuthorizationOverride: undefined | null | string,
  isJSON: undefined | null | boolean
): RequestArgs => {
  const headers = args[1].headers || new Headers();
  const authorization = AuthorizationOverride || getToken();
  if (authorization) {
    headers.set('Authorization', authorization);
  }
  if (isJSON) {
    headers.append('Accept', 'application/json, text/plain, */*');
  }
  return [args[0], { ...args[1], headers }];
};

type AuthorizationOverride = { AuthorizationOverride?: string };

type AuthorisedGetArgs = BuildGetArgs & AuthorizationOverride;

type AuthorisedPostArgs = BuildPostArgs & AuthorizationOverride;

export const postAuthorised = ({
  AuthorizationOverride,
  ...args
}: AuthorisedPostArgs) => {
  const authorisedArgs = requestAuthorised(
    buildPost(args),
    AuthorizationOverride,
    !!args.postJSON
  );
  return performFetch({
    args: authorisedArgs,
    sourceFile: AUTH_HTTP_SOURCE_FILE,
  });
};

export const postAuthorisedJSON = (
  args: AuthorisedPostArgs,
  logRequestDataOnFail?: boolean
) => {
  let request = postAuthorised(args).then((response: Response) =>
    logRequestDataOnFail
      ? handleJSON({ resp: response, sourceFile: AUTH_HTTP_SOURCE_FILE, args })
      : handleJSON({ resp: response, sourceFile: AUTH_HTTP_SOURCE_FILE })
  );
  return request;
};

export const getAuthorised = ({
  AuthorizationOverride,
  ...args
}: AuthorisedGetArgs) => {
  const authorisedArgs = requestAuthorised(
    buildGet(args),
    AuthorizationOverride,
    false
  );
  return performFetch({
    args: authorisedArgs,
    sourceFile: AUTH_HTTP_SOURCE_FILE,
  });
};
